import { useaxios } from "../../../utils/useaxios";
export default (category_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    initDispatch({ type: 'loadingTrue' });
    useaxios('category/delete.php', { category_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            clear();
        }
        // setloading(false);
    });
}